export function renderBuildAuthorshipDataFieldsContentTemplate(): string {
  return `  createdByUser: AdminUserSummary | null
  updatedByUser: AdminUserSummary | null`
}
